import React from "react";
import { inIframe } from "utils";
import { FullPage } from "./FullPage";
import { IFrame } from "./IFrame";
import { TOSForm } from "./TOSForm";

export const TOS = (props) => {
  const Container = inIframe() ? IFrame : FullPage;
  return (
    <Container>
      <TOSForm {...props} />
    </Container>
  );
};
